// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"snRWM"};